import { useEffect, useState } from "react";
import { swrJson } from "@/lib/swr";
import { RefreshButton } from "@/components/RefreshButton";
import { useTenant } from "@/lib/tenant";

const wib = (d?: string | null) => (d ? new Date(new Date(d).getTime() + 7 * 3600e3).toISOString().slice(0, 10) : "—");

/** Cakupan data per vendor + tombol tarik ulang. Ringkas: rentang tanggal & jumlah,
 *  bukan paragraf timestamp seperti versi sebelumnya. */
export function SyncBar({ wing }: { wing?: "media" | "social" } = {}) {
  // Cakupan vendor yang tidak dilanggan tenant ini tidak ditampilkan: "Social 0"
  // pada tenant media-only terbaca sebagai data hilang, bukan sebagai modul
  // yang memang tidak dibeli.
  const { has } = useTenant();
  const [f, setF] = useState<any>(null);
  useEffect(() => { swrJson("/api/v1/datasources/freshness", (d) => { if (d) setF(d); }); }, []);
  if (!f) return null;
  const v = (k: "digivla" | "neticle") => f.coverageByVendor?.[k] ?? {};
  const nf = (x: number) => Intl.NumberFormat("id-ID").format(x ?? 0);
  const Item = ({ icon, label, k }: { icon: string; label: string; k: "digivla" | "neticle" }) => (
    <span className="avio-leg__i" style={{ gap: "var(--space-4)" }}>
      <i className={icon} style={{ color: "var(--color-text-muted)" }} />
      <span>{label}</span>
      <b>{nf(v(k).total ?? 0)}</b>
      <span style={{ color: "var(--color-text-muted)" }}>{wib(v(k).from)} → {wib(v(k).to)}</span>
    </span>
  );
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "var(--space-7)", flexWrap: "wrap", marginBottom: "var(--space-6)" }}>
      {has("media_monitoring") && <Item icon="fa-solid fa-newspaper" label="Media massa" k="digivla" />}
      {has("social_monitoring") && <Item icon="fa-solid fa-bullhorn" label="Social" k="neticle" />}
      <span style={{ marginLeft: "auto", display: "flex", gap: "var(--space-5)", alignItems: "center" }}>
        {wing && <RefreshButton wing={wing} />}
      </span>
    </div>
  );
}
